import { TimeEntryBookingLocationDTO } from './timeEntryBookingLocationDTO'

/**
 * Represents a single booking entry.
 */
export class TimeEntryBookingDTO {
  /**
   * @param {Object} bookingData - The booking data object.
   * @param {number} bookingData.id - Unique identifier for the booking.
   * @param {Object} bookingData.location - Location details of the booking.
   * @param {string} bookingData.startDateLocal - Start date and time in local format.
   * @param {string} bookingData.endDateLocal - End date and time in local format.
   * @param {TimeEntryBookingForm} bookingData.form - The form object.
   */
  constructor(bookingData) {
    /**
     * Unique identifier for the booking.
     * @type {number}
     */
    this.id = bookingData.id

    /**
     * Location details of the booking.
     * @type {TimeEntryBookingLocationDTO}
     */
    this.location = new TimeEntryBookingLocationDTO(bookingData.location)

    /**
     * Start date and time of the booking in local time.
     * @type {Date}
     */
    this.startDateLocal = new Date(bookingData.startDateLocal)

    /**
     * End date and time of the booking in local time.
     * @type {Date}
     */
    this.endDateLocal = new Date(bookingData.endDateLocal)

    /**
     * @type {TimeEntryBookingForm}
     */
    this.form = bookingData.form
      ? new TimeEntryBookingForm(bookingData.form)
      : null
  }

  /**
   * Checks if the form property is set, signaling that the UI should
   * render a form.
   * @returns {boolean} True if the option exists, false otherwise.
   */
  shouldRenderForm() {
    return !!this.form
  }
}

export class TimeEntryBookingForm {
  /**
   * @param {Object} formData
   * @param {Object} formData.retrospectiveTime
   */
  constructor(formData = {}) {
    /**
     * @type {RetrospectiveTimeInputModel}
     */
    this.retrospectiveTime = new RetrospectiveTimeInputModel(
      formData?.retrospectiveTime
    )
  }
}

export class RetrospectiveTimeInputModel {
  /**
   * @param {Object} params
   * @param {boolean} params.enable
   */
  constructor(params) {
    /**
     * @type {boolean}
     */
    this.enable = params.enable
  }
}
